$(document).ready(function () {
    /**
     * TCR Module implementation
     */
    /* Commented out due to Safari:
       > undefined is not an object (evaluating 'this.mWindow['safari']') */
    // var tcr=document.createElement('script'); 
    // tcr.src = 'https://www2.gundrymdtotalrestore.com/assets/js/site.js';
    // document.body.appendChild(tcr);

    // let results = {};
    // let value, key;
    // let objectStructure = null;
    // let index = 0;
    // function createObj(obj) {
    //     key = obj.closest('.box').find('h2').data('title');
    //     value = obj.closest('li').find('input').val();
    //     if (objectStructure == null) {
    //         results[key] = value;
    //     } else if (obj.closest('.box').hasClass('box--multiple-answer')) {
    //         if (typeof results[key] === 'object') {
    //             results[key][index++] = value;
    //         } else {
    //             results[key] = {};
    //             results[key][index++] = value;
    //         }
    //         objectStructure = results
    //     } else {
    //         results[key] = value;
    //     }
    //     objectStructure = results;
    //     // console.log(objectStructure);
    //     funnelEventEmitter('surveyResults', objectStructure);
    // }

    function pagination() {
        const boxes = $('.boxes');        

        $('#nextStep').addClass('hidden');

        $('.answers li').on('click', function () {            
            if ($(this).parent().attr('data-answer') == 'checkbox') {

                $(this).toggleClass('checked');
                $('#proceedStep').removeClass('hidden').addClass('show');

            } else {
                $('.answers li').removeClass('checked');
                $(this).addClass('checked');
            }

            if (boxes.hasClass('one')) {
                boxes.removeClass('one').addClass('two');

            } else if (boxes.hasClass('two') && !boxes.hasClass('boxes--2Sections') && $(this).parent().attr('data-answer') == 'radio') {
                boxes.removeClass('two').addClass('three');
            }
        });

        $('#proceedStep').on('click', function() {
            if (boxes.hasClass('two')) {
                boxes.removeClass('two').addClass('three');
            }

            $('#proceedStep').removeClass('show').addClass('hidden');
        })

        if(boxes.hasClass('boxes--2Sections')) {
            $('.box.two .answers li').on('click', function () {
                $('#nextStep').removeClass('hidden').addClass('show');
                $('.boxes.two .box').addClass('clicked');
                $('.skip').addClass('clicked');
            })

        } else {
            $('.box.three .answers li').on('click', function () {
                $('#nextStep').removeClass('hidden').addClass('show');
                $('.boxes.three .box').addClass('clicked');
                $('.skip').addClass('clicked');
            })
        }
    }

    // if($(window).width() < 992) {
    //     $('.answers > li').on('click', function () {
    //         const boxes = $('.boxes');
    //         createObj($(this));
    //     })
    // } else {
    //     $('.answers label, .answers input').on('click', function () {
    //         const boxes = $('.boxes');
    //         createObj($(this));
    //     })
    // }

    if (!$('body').hasClass('surveyPage--desktop') || $(window).width() < 992) {
        pagination()
    }
});